import { ContentStore } from '@app/api';
import { marked } from 'marked';
import { useEffect, useState } from 'react';

export const useTermsAndConditionsController = () => {
  const [terms, setTerms] = useState<{ title: string; content: string; version: number }>({
    title: '',
    content: '',
    version: 0,
  });
  useEffect(() => {
    new ContentStore()
      .readByContentType('termsAndConditions', (item) => {
        return {
          title: String(item.fields['title']),
          content: marked(String(item.fields['content']), { async: false }),
          version: Number(item.sys.publishedVersion),
        };
      })
      .then((content) => {
        setTerms(content[0]);
      });
  }, []);
  return {
    terms,
  };
};
